import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {RomanEmpireEvents} from "../events/RomanEmpireEvents";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireGameModuleConfig} from "../RomanEmpireGameModuleConfig";
import {RomanEmpireParsedGameData} from "../server/data/RomanEmpireParsedGameData";
import {RomanEmpireGameMode} from "../gamemode/RomanEmpireGameMode";
import {WalkingWildView} from "../walkingwild/WalkingWildView";
import {SoundManager} from "../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../RomanEmpireSoundConfig";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class RomanEmpireReelController extends SpinReelController {
    private _reelAttentionLayer: PIXI.Container;
    private _anticipationContainer: PIXI.Container;
    private _scatterInReels: number[] = [];
    private isRandomBothWaysTriggered: boolean = false;
    private _isReSpin: boolean = false;
    private _isReSpinTriggered: boolean = false;
    private _fsAniticpation: TimelineSprite[] = [];

    constructor(reelId: number) {
        super(reelId);
        this.createAnticipationContainer();
    }

    private createFsAniticpationLastPart(): void {
        for (let reelId = 0; reelId < RomanEmpireGameConfig.instance.REELS_NUM; reelId++) {
            const posX: number = RomanEmpireGameConfig.instance.REEL_AREA_POS_X + RomanEmpireGameConfig.instance.SYMBOL_WIDTH * reelId + RomanEmpireGameConfig.instance.SYMBOL_WIDTH * 0.5;
            const posY: number = RomanEmpireGameConfig.instance.REEL_AREA_POS_Y + RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT * 0.5;
            const anticipationAnim = this.createSprite("fsAnticipation", [posX, posY], undefined, true);
            anticipationAnim.blendMode = PIXI.BLEND_MODES.ADD;
            this._fsAniticpation.push(anticipationAnim);
        }

    }

    protected getNormalStopDelay(reelId: number): number {
        if (this.isRandomBothWaysTriggered && reelId === 0) {
            return 5;
        }
        if (this._isReSpin && reelId === 0) {//&& reelId === 0
            return WalkingWildView.WALKING_Wild_DURATION;
        }

        return this.isRandomBothWaysTriggered ? 1 : super.getNormalStopDelay(reelId);
        //for quick stop we used normal delay and for normal we used 1 for GenieLamp feature.
        //return super.getNormalStopDelay(reelId);
    }

    private createAnticipationContainer() {
        this._reelAttentionLayer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.REEL_ATTENTION.name);
        this._anticipationContainer = new PIXI.Container();
        this._anticipationContainer.name = "ANTICIPATION";
        this._reelAttentionLayer.addChild(this._anticipationContainer);
    }

    protected addEventListeners(): void {
        super.addEventListeners();
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_GAME_START, () => this.scatterToTopOnInit());
        EventHandler.addEventListener(this, RomanEmpireEvents.PLAY_SCATTER_ANTICIPATION_ANIM, (event: GameEvent) => this.playAnticipation(event.params[0]));
        EventHandler.addEventListener(this, RomanEmpireEvents.HIDE_SCATTER_ANTICIPATION_ANIM, (event: GameEvent) => {
            this._anticipationContainer && this._anticipationContainer.removeChildren();
        });
    }

    private playAnticipationSound(){
        Logger.logDev("anticipationSound playAnticipationSound");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.SCATTER_ANTICIPATION);
        if(this._isReSpin){
            SoundManager.fadeSound(RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS, 170, 0.5);
        }else{
            SoundManager.fadeSound(RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 170, 0);
            SoundManager.fadeSound(RomanEmpireSoundConfig.instance.MEDIUM_AND_LARGE_WIN, 170, 0);
        }
    }

    public onGameDataParsed(data: RomanEmpireParsedGameData): void {
        super.onGameDataParsed(data);
        this.isRandomBothWaysTriggered = data.isRandomBothWaysTriggered;
        this._isReSpin = data.mode === RomanEmpireGameMode.GENIE_RESPIN;
        if (data.mode === RomanEmpireGameMode.GENIE_RESPIN) {
            this.playAnticipation(0);
        }
        this._isReSpinTriggered = data.mode == RomanEmpireGameMode.NORMAL && data.isNextGenieReSpin;
    }

    protected onSpinStartedCompleted(): void {
        Logger.logDev("expandingWild Logs : onSpinStartedCompleted");
        super.onSpinStartedCompleted();
    }

    private playAnticipation(reelId: number) {
        if (!this._fsAniticpation.length) {
            this.createFsAniticpationLastPart();

        }
        if (reelId !== this.reelId) {
            return;
        }

        if (!this._anticipationContainer) {
            return;
        }
        if (this._nearWinReels.indexOf(true) === reelId) {
            this.playAnticipationSound();
        }
        if (this._nearWinReels[reelId] && (this.currentState === ReelAnimationState.SPIN || this.currentState === ReelAnimationState.START_SPIN)) {
            this._anticipationContainer.removeChildren();
            const tl = new TimelineLite({
                onComplete: () => {
                }
            });
            const posX: number = RomanEmpireGameConfig.instance.REEL_AREA_POS_X + RomanEmpireGameConfig.instance.SYMBOL_WIDTH * reelId + RomanEmpireGameConfig.instance.SYMBOL_WIDTH * 0.5;
            const posY: number = RomanEmpireGameConfig.instance.REEL_AREA_POS_Y + RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT * 0.5;
            const glowSprite: TimelineSprite = this.createSprite("anticipationGlow", [posX, posY], undefined, true);
            const trailSprite: TimelineSprite = this.createSprite("anticipationTrail", [posX, 0], undefined, true);
            const trailSpriteReverse: TimelineSprite = this.createSprite("anticipationTrail", [posX, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y + trailSprite.height * 0.5], undefined, true);
            this._anticipationContainer.addChild(glowSprite, this._fsAniticpation[reelId], trailSprite, trailSpriteReverse);
            trailSpriteReverse.scale.x *= -1;
            trailSpriteReverse.scale.y *= -1;
            trailSprite.anchor.y = 1;
            trailSpriteReverse.anchor.y = 1;
            trailSprite.position.y = RomanEmpireGameConfig.instance.REEL_AREA_POS_Y + RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT + 60;
            trailSpriteReverse.position.y = RomanEmpireGameConfig.instance.REEL_AREA_POS_Y - 70;
            trailSprite.blendMode = PIXI.BLEND_MODES.ADD;
            trailSpriteReverse.blendMode = PIXI.BLEND_MODES.ADD;
            trailSprite.alpha = 0.7;
            trailSpriteReverse.alpha = 0.7;

            this._fsAniticpation[reelId].visible = false;
            glowSprite.hide();
            trailSprite.hide();
            trailSpriteReverse.hide();

            if (this._isReSpin && this._reelId == 0) {
                tl.delay(WalkingWildView.WALKING_Wild_DURATION);
            }
            tl.add([() => {
                //SoundManager.stopSound(RomanEmpireSoundConfig.instance.SCATTER_ANTICIPATION_SWEEP);
                SoundManager.playSound(RomanEmpireSoundConfig.instance.SCATTER_ANTICIPATION_SWEEP);
                glowSprite.show();
                trailSprite.show();
                trailSpriteReverse.show();
                //this._fsAniticpation[reelId].visible = false;
                glowSprite.playLoop();
                if (this._gameMode === RomanEmpireGameMode.GENIE_RESPIN) {
                    this._fsAniticpation[reelId].visible = true;
                    this._fsAniticpation[reelId].playLoop();
                }
            }, trailSprite.getAnimationAutoShowHide(true, true), trailSpriteReverse.getAnimationAutoShowHide(true, true)]);
            tl.play();
        }
    }


    private createSprite(texture: string, position?: number[], sourceFPS?: number, isJPEG: boolean = false): TimelineSprite {
        const textures: PIXI.Texture[] = GameResources.getTextures(texture);
        const sprite: TimelineSprite = new TimelineSprite(textures, sourceFPS);
        sprite.anchor.set(0.5, 0.5);
        if (position) {
            sprite.position.set(position[0], position[1]);
        }
        isJPEG && (sprite.blendMode = PIXI.BLEND_MODES.ADD);
        return sprite;
    }

    protected onSpinStopAnimationCompleted() {
        super.onSpinStopAnimationCompleted();
        if (this._anticipationContainer) {
            this._anticipationContainer.removeChildren();
        }
    }

    stopSpin(stopData: IReelStopSpinData, previousStopTime: number): number {
        const delay: number = super.stopSpin(stopData, previousStopTime);
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_REEL_STOP_SPIN, this.reelId, delay, stopData));
        return delay;
    }

    protected getQuickStopDelay(reelId: number): number {
        if (this.isRandomBothWaysTriggered && reelId === 0) {
            return 5;
        }
        if (this._isReSpin && reelId === 0) {//
            return WalkingWildView.WALKING_Wild_DURATION;
        }
        return this.isRandomBothWaysTriggered ? RomanEmpireGameConfig.instance.REEL_STOP_DELAY : RomanEmpireGameConfig.instance.REEL_QUICK_STOP_DELAY;
        //for quick stop we used normal delay and for normal we used 1 for GenieLamp feature.
    }

    protected getFastSpinStopDelay(reelId: number): number {
        return super.getFastSpinStopDelay(reelId);
    }

    private getScatterPositionFromReelSet(reels: string[][]): number[] {
        let scatterPos: number[] = [-1, -1, -1, -1, -1];
        reels.forEach((value: string[], index: number) => {
            reels[index].indexOf("S") !== -1 && (scatterPos[index] = reels[index].indexOf("S"));
        });

        return scatterPos;
    }

    protected onInitDataParsed(data: ParsedInitData): void {
        super.onInitDataParsed(data);
        this._scatterInReels = this.getScatterPositionFromReelSet(data.reels);
    }

    private scatterToTopOnInit(): void {
        const reelController = Reels.getReel(this.reelId);
        if (reelController?.allSymbols.length) {
            reelController?.allSymbols.forEach((sym, index) => {
                if (sym!.symName === "M1") { // to Fix #67
                    reelController && reelController.moveSymbolToTop(index - RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[0]);
                }
            });
            for (let index = reelController?.allSymbols.length - 1; index > 0; index--) {
                const sym = reelController?.allSymbols[index];
                if (sym!.symName === "S") {
                    reelController && reelController.moveSymbolToTop(index - RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[0]);
                }
            }
        }

        // if (this._scatterInReels[this.reelId] != -1) {
        //     reelController && reelController.moveSymbolToTop(this._scatterInReels[this.reelId]);
        // }
    }

    protected getNearWinStopDelay(reelId: number): number {
        if (this._isReSpin) {
            if (reelId == 0) {
                return WalkingWildView.WALKING_Wild_DURATION + RomanEmpireGameConfig.instance.REEL_RESPIN_NEAR_WIN_STOP_DELAY[reelId];
            }
            return RomanEmpireGameConfig.instance.REEL_RESPIN_NEAR_WIN_STOP_DELAY[reelId]; //Added to fix #193
        }
        return super.getNearWinStopDelay(reelId);
    }


}
